import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { Space, Switch } from 'antd';
export const InactiveToggle = ({ checked, onChange }) => {
    // Switch onChange passes a second argument that cannot be passed
    // When provided onChange is a setState function.
    const handleOnChange = useCallback((value) => onChange({ hideInactive: !value }), [onChange]);
    return (React.createElement(Space, null,
        React.createElement("span", null, COPY_GENERIC.SHOW_INACTIVE),
        React.createElement(Switch, { checked: !checked, onChange: handleOnChange })));
};
